import React from 'react';
import Icon from './Icon';

const Check = (props) => (
  <Icon viewBox="0 0 200 200" {...props}>
    <title>Check</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle fill="#ebebeb" cx="100" cy="100" r="100"></circle>
        <g transform="translate(31.000000, 26.000000)">
          <g>
            <polygon points="0 0 138 0 138 138 0 138"></polygon>
            <polygon fill="#FFFFFF" points="50.2 92.95 26.05 68.8 18 76.85 50.2 109.05 119.2 40.05 111.15 32"></polygon>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);

export default Check;
